// TB-080 (DEF-165): web notification calls.
// GET my-notifications used to mark every notification seen as a side effect,
// so opening a dashboard or the Notifications page cleared the unread badge.
// The web now lists with markSeen=false and marks seen only on an explicit
// action (Mark all as read, Mark as read, or opening a notification).
// transactions-api: GET my-notifications?markSeen=false,
// PATCH my-notifications/seen { ids?: uuid[] } (no ids = all of the caller's).
import emitter from '@/event-bus.js'

function txBase () {
  return process.env.VUE_APP_TRANSACTIONS_SERVICE_API || ''
}

export function listUrl () {
  return `${txBase()}my-notifications?markSeen=false`
}

export function markSeenUrl () {
  return `${txBase()}my-notifications/seen`
}

/** Notifications of the caller, newest first, without marking anything seen. */
export function listNotifications (http) {
  return http.get(listUrl()).then((res) => {
    const list = res && res.data && Array.isArray(res.data.data) ? res.data.data : []
    return list.map((n) => (n && typeof n.description === 'string' ? { ...n, description: readableDates(n.description) } : n))
  })
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** Server messages carry raw "2026-10-19 12:30" stamps; show "19 Oct 2026, 12:30 PM". */
export function readableDates (text) {
  return String(text).replace(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?Z?)?/g, (m, y, mo, d, h, mi) => {
    const month = MONTHS[Number(mo) - 1]
    if (!month) return m
    const date = `${Number(d)} ${month} ${y}`
    if (h === undefined) return date
    const hh = Number(h)
    return `${date}, ${hh % 12 || 12}:${mi} ${hh < 12 ? 'AM' : 'PM'}`
  })
}

/** True when the row has not been marked seen on the server. */
export function isUnread (n) {
  return !!n && n.seen === false
}

/**
 * Marks the given notification ids seen, or all of the caller's when ids is
 * omitted. Resolves with the number updated. Asks the side-menu badge to
 * refresh afterwards.
 */
export function markNotificationsSeen (http, ids) {
  const body = Array.isArray(ids) ? { ids } : {}
  return http.patch(markSeenUrl(), body).then((res) => {
    try { emitter.emit('navCountsRefresh') } catch (e) { /* no listener */ }
    const updated = res && res.data && res.data.data && res.data.data.updated
    return { updated: Number(updated) || 0, message: (res && res.data && res.data.message) || '' }
  })
}
